export const followerStatus = {
  READY: 1,
  SUBMITTING: 2,
  COMPLETE: 3,
  ERROR: 4
};

export default { followerStatus };
